import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TransactionStatusEnum } from '@blockcatio/tabby-library/lib/constants';

import RedeemReward from './RedeemReward';
import { redeemRewardCode } from '../../actions/redeemReward';
import { parseCode } from '../../utilities/codeParser';

const mapStateToProps = state => ({
  redemptionStatus: state.redeemReward.redemptionStatus,
});

const mapDispatchToProps = dispatch => ({
  onRedeemReward: (campaignId, number, code) =>
    dispatch(redeemRewardCode(campaignId, number, code)),
});

export class RedeemRewardContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      didSend: false,
      errorMessage: '',
    };

    this.handleClick = this.handleClick.bind(this);
  }

  async handleClick() {
    this.setState({ errorMessage: '', didSend: false });
    const { code: expandedCode, onRedeemReward } = this.props;
    try {
      const { campaignId, number, code } = parseCode(expandedCode);
      const transactionHash = await onRedeemReward(campaignId, number, code);
      if (transactionHash) {
        this.setState({ didSend: true });
      }
    } catch (error) {
      this.setState({ errorMessage: error.message });
    }
  }

  render() {
    const { redemptionStatus } = this.props;
    const { didSend, errorMessage } = this.state;
    return (
      <RedeemReward
        redemptionStatus={redemptionStatus}
        didSend={didSend}
        errorMessage={errorMessage}
        onRedeemReward={this.handleClick}
      />
    );
  }
}

RedeemRewardContainer.displayName = 'RedeemRewardContainer';

RedeemRewardContainer.defaultProps = {
  code: '',
  redemptionStatus: TransactionStatusEnum.pending,
};

RedeemRewardContainer.propTypes = {
  code: PropTypes.string,
  redemptionStatus: PropTypes.number,
};

export default connect(mapStateToProps, mapDispatchToProps)(RedeemRewardContainer);



// WEBPACK FOOTER //
// ./src/containers/redeemReward/RedeemRewardContainer.js